export const ArrowLeft = () => {
  return (
    <svg width={11} height={19} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.13 9.279l9.125 8.427M1.13 9.279L10.254.852"
      stroke='currentColor'
      strokeWidth={1.442}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export const ArrowRight = () => {
    return (
      <svg
  width={12}
  height={19}
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.738 9.829l-9.124 8.427M10.738 9.829L1.614 1.402"
    stroke='currentColor'
    strokeWidth={1.442}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
    )
}